import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=0d67eb3a&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=ts&"
export * from "./HelloWorld.vue?vue&type=script&lang=ts&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=0d67eb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67eb3a",
  null
  
)

export default component.exports